<template>
  <div style="height: 100%;">
    <el-container>
      <el-aside style="width: auto; ">
        <side-menu-bar>
        </side-menu-bar>
      </el-aside>
      <el-container>
        <el-header>
          <header-bar></header-bar>
        </el-header>
        <el-main>
          <div style="background-color: #F2F6FC; height: 2px; width: 100%;"></div>
          <tab-bar></tab-bar>
          <div style="background-color: #F2F6FC; height: 5px; width: 100%;"></div>
          <main-content></main-content>
          <div style="background-color: #F2F6FC; height: 5px; width: 100%;"></div>
        </el-main>
      </el-container>
    </el-container>

    <!--   <el-container v-if="radioLayout == '2'">
      <el-header>
        <header-bar></header-bar>
      </el-header>
      <el-container>
        <el-aside style="width: auto;">
          <side-menu-bar></side-menu-bar>
        </el-aside>
        <el-container>
          <el-main>
            <div style="background-color: #F2F6FC; height: 2px; width: 100%;"></div>
            <tab-bar></tab-bar>
            <div style="background-color: #F2F6FC; height: 2px; width: 100%;"></div>
            <main-content></main-content>
          </el-main>
        </el-container>
      </el-container>
    </el-container>

 -->





    <el-drawer title="表格自定义" :visible.sync="drawer" :direction="direction" size="480">
      <span slot="title">
        <el-select v-model="radio" placeholder="请选择" @change="handleChange" size="small" style="width: 100px;">
          <el-option v-for="item in tables" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <span style="color:#F56C6C;  ">调整后请刷新界面</span>
        <el-button type="primary" size="small" @click="handelDefault">恢复默认</el-button>
      </span>
      <span>
        <el-table :data="tableData" stripe border @cell-dblclick="handleCelldbclick">
          <el-table-column prop="sort" label="序号" width="60" show-overflow-tooltip header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="label" label="列名" width="100" show-overflow-tooltip header-align="center"
            align="center">
          </el-table-column>
          <el-table-column prop="showFlag" label="显示" width="50" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">
                <el-checkbox size="small" v-model="scope.row.showFlag" true-label="1" false-label="0" @change="checkboxChange(scope.row,'showFlag')" ></el-checkbox>
           <!--   <el-tag size="small" v-if="scope.row.showFlag == '1'" type="success">是</el-tag>
              <el-tag size="small" v-else type="danger">否</el-tag> -->
            </template>
          </el-table-column>
          <el-table-column prop="align" label="对齐" width="70" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.align == 'left'" type="warning">左对齐</el-tag>
              <el-tag size="small" v-else-if="scope.row.align == 'right'" type="info">右对齐</el-tag>
              <el-tag size="small" v-else>居中</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sortable" label="排序" width="50" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">
               <el-checkbox size="small" v-model="scope.row.sortable" true-label="1" false-label="0" @change="checkboxChange(scope.row,'sortable')" ></el-checkbox>
<!--              <el-tag size="small" v-if="scope.row.sortable == '1'" type="success">是</el-tag>
              <el-tag size="small" v-else type="danger">否</el-tag> -->
            </template>
          </el-table-column>
          <el-table-column prop="exportFlag" label="导出" width="50" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">
                <el-checkbox size="small" v-model="scope.row.exportFlag" true-label="1" false-label="0" @change="checkboxChange(scope.row,'exportFlag')" ></el-checkbox>
<!--              <el-tag size="small" v-if="scope.row.exportFlag == '1'" type="success">是</el-tag>
              <el-tag size="small" v-else type="danger">否</el-tag> -->
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100px" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-top" circle @click="handleMove(scope.row,'up')">
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-bottom" circle @click="handleMove(scope.row,'down')">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </span>
    </el-drawer>

    <el-drawer title="系统设置" :visible.sync="setting" :direction="direction" size="400" :before-close="handleClose">
      <el-form label-width="80px">
        <el-form-item label="布局">
          <el-radio-group v-model="radioLayout" @change="handleChangeLayout" size="small" style="width:300px;">
            <el-radio-button label="1">标准</el-radio-button>
            <el-radio-button label="2">通透</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="导航类型">
          <el-radio-group v-model="radioNav" @change="handleChangeNav" size="small" style="width:300px;">
            <el-radio-button label="tag"></el-radio-button>
            <el-radio-button label="tab"></el-radio-button>
          </el-radio-group>
        </el-form-item>



        <el-form-item label="logo显示">
          <el-switch v-model="radioLogoShow" @change="handleChangeLogoShow" size="small" style="width:300px">
          </el-switch>
        </el-form-item>

        <el-form-item label="logo位置">
          <el-radio-group v-model="radioLogoPosition" @change="handleChangeLogoPosition" size="small"
            style="width:300px">
            <el-radio-button label="left">左侧</el-radio-button>
            <el-radio-button label="right">右侧</el-radio-button>
          </el-radio-group>
        </el-form-item>

      </el-form>

    </el-drawer>


    <div class="dragIcon" @click="click"  >
      个性化
    </div>
  </div>
</template>
<script>
  import HeaderBar from "./HeaderBar"
  import SideMenuBar from './SideMenuBar'
  import MainContent from './MainContent'
  import TabBar from './TabBar'
  import axios from '@/axios'
  import {
    mapState,
    mapGetters
  } from 'vuex'
  export default {

    data() {
      return {
        drawer: false,
        direction: 'rtl',
        left: 0,
        top: 1000,
        itemWidth: 40,
        itemHeight: 40,
        clientW: document.documentElement.clientWidth,
        clientH: document.documentElement.clientHeight,
        radio: '',
        tables: [],
        tableData: [],
        dialogVisible: false,
        tablePersonal: {},
        // url: require('../../../assets/img/sd.png'),
        // navType: localStorage.getItem('navType')
        radioLayout: '1',
        radioNav: 'tab',
        radioLogoShow: true,
        radioLogoPosition: 'left',
      };
    },
    computed: {
      // collapse() {
      //   console.log(this.$store.getters.collapse)
      //   return this.$store.getters.collapse
      // ,'navType'},
      ...mapGetters(['setting', 'navType', 'collapse', 'logoShow', 'logoPosition', 'layout']),

      ...mapState({
        openedPageList: state => state.tabsbar.openedPageList,
        activePage: state => state.tabsbar.activePage,
        appName: state => state.app.appName,
        subName: state => state.app.subName,
        secName: state => state.app.secName,
      })
    },
    components: {
      HeaderBar,
      SideMenuBar,
      MainContent,
      TabBar
    },
    methods: {
      handleClose(done) {
        this.$store.commit('setSetting')
      },
      handleChangeNav(value) {
        console.log(value)
        this.$store.commit('setNavType', value)
        // navType : localStorage.setItem('navType',type)
      },

      handleChangeLogoShow(value) {
        console.log(value)
        this.$store.commit('setLogoShow', value)
        // navType : localStorage.setItem('navType',type)
      },

      handleChangeLogoPosition(value) {
        console.log(value)
        this.$store.commit('setLogoPosition', value)
        // navType : localStorage.setItem('navType',type)
      },
      handleChangeLayout(value) {

        var position = ''
        if (value == '1') {
          position = 'left'
        } else if (value == '2') {
          position = 'right'
        }

        this.radioLayout = value
        this.$store.commit('setLayout', value)
        this.radioLogoShow = true
        this.$store.commit('setLogoShow', true)
        this.radioLogoPosition = position
        this.$store.commit('setLogoPosition', position)

      },
      click() {
        this.drawer = true
        this.getTables()
      },
      handleChange(val) {
        this.getTableData()
      },
      getTables() {
        var url = 'framework/TablePersonal/queryTNameByUserIdMenuId.do'
        var param = {
          menuId: localStorage.getItem('menuId')
        }
        axios.get(url, param).then(response => {
          this.tables = response.data.data
          if (this.tables.length > 0) {
            this.radio = this.tables[0]
            this.getTableData()
          } else {
            this.tableData = []
          }
        });
      },
      getTableData() {
        var url = 'framework/TablePersonal/queryByUserIdMenuId.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          tName: this.radio
        }
        axios.get(url, param).then(response => {

          this.tableData = response.data.data
        });
      },
      handleCelldbclick(row, column, cell, event) {
        var url = 'framework/TablePersonal/modify.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          row: JSON.stringify(row),
          col: column.property,
          tName: this.radio
        }
        axios.post(url, param).then(response => {
          this.getTableData()
        });
      },

      checkboxChange(row,type){
        var url = 'framework/TablePersonal/modify.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          row: JSON.stringify(row),
          col: type,
          tName: this.radio
        }
        axios.post(url, param).then(response => {
          this.getTableData()
        });
      },




      handleMove(row, type) {
        var url = 'framework/TablePersonal/move.do'
        var param = {
          menuId: localStorage.getItem('menuId'),
          row: JSON.stringify(row),
          type: type,
          tName: this.radio
        }
        axios.post(url, param).then(response => {
          this.getTableData()
        });
      },
      handelDefault() {
        this.$confirm('此操作将恢复“' + this.radio + '”表格默认设置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          var url = 'framework/TablePersonal/restore.do'
          var param = {
            menuId: localStorage.getItem('menuId'),
            tName: this.radio
          }
          axios.post(url, param).then(response => {
            this.getTableData()
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    },
    mounted() {
      this.radioLayout = this.layout
      this.radioNav = this.navType
      this.radioLogoShow = this.logoShow
      this.radioLogoPosition = this.logoPosition




      if (this.activePage.path == '/home') {
        this.$router.push('/home/main');
      } else {
        this.$router.push(this.activePage.path);
      }

    },
    created() {
      this.left = (this.clientW - this.itemWidth - 30)
      this.top = (this.clientH - this.itemHeight)

    }

  }
</script>
<style>
  .dragIcon {
    position: fixed;
    bottom: 20px;
    right:20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #409EFF;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 12px;
  }

  .logo_main {
    height: 60px;
    margin-right: 1px;
    background-color: #304156;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .logo_img {
    width: 40px;
    height: 40px;
  }

  .logo_text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .logo_text_detail {
    font-size: 16px;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/home/home.vue